import AboutMe from './AboutMe';
import Experience from './Experience';
import Education from './Education';
import Projects from './MyPortfolio';
import Skills from './MySkills';
import Footer from './Footer';

export default function Home() {
  const handleSayHello = () => {
    window.open('https://www.linkedin.com/messaging/', '_blank', 'noopener,noreferrer');
  };

  const handleDownloadResume = () => {
    const resumeUrl = `${process.env.PUBLIC_URL}/KumkumChoudhary_Resume.pdf`;
    const link = document.createElement('a');
    link.href = resumeUrl;
    link.download = 'KumkumChoudhary_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div id="home" className="homepage-container">
        <div className="homepage-content">
          <h1 className="homepage-title">Hi, I&apos;m kumkum!</h1>
          <div className="homepage-subtitle">
            AI Integrations Engineer | Cognitive Science Researcher
          </div>
          <div className="homepage-buttons">
            <button className="homepage-btn say-hello-btn" onClick={handleSayHello}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              Say Hello
            </button>
            <button className="homepage-btn download-resume-btn" onClick={handleDownloadResume}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
              </svg>
              Download Resume
            </button>
          </div>
        </div>
        <div className="homepage-image">
          <img src="/img/me2.png" alt="Kumkum" />
        </div>
      </div>
      <AboutMe />
      <Experience />
      <Education />
      <Projects />
      <Skills />
      <Footer />
    </>
  );
}
